import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SEO = () => {
  const location = useLocation();

  const seoData = {
    "/": {
      title: "Maid Service in Mumbai | Hire Maid in Mumbai",
      description:
        "Hire trusted maids, babysitters, cooks, drivers and patient care services in Mumbai with Tanya Maid Service.",
    },

    "/about-us": {
      title: "Maid Service Agency in Mumbai | Tanya Maid Service",
      description:
        "Tanya Maid Service provides professional maid, babysitter, patient care and home cleaning services across Mumbai.",
    },

    "/contact": {
      title: "Contact Tanya Maid Service Mumbai",
      description:
        "Contact Tanya Maid Service for trusted maid, babysitter, cook and cleaning services in Mumbai.",
    },

    "/services": {
      title: "Maid Services in Mumbai | Tanya Maid Service",
      description:
        "Explore maid services including babysitter, cooking, driver, patient care and home cleaning in Mumbai.",
    },

"/services/patient-care-service-in-mumbai": {
  title: "Patient Care Services in Mumbai | Tanya Maid Service",
  description:
    "Professional patient care and caretaker services in Mumbai for elderly and home care support.",
},

"/services/baby-care-service-in-mumbai": {
  title: "Babysitter Services in Mumbai | Tanya Maid Service",
  description:
    "Hire experienced babysitters and nanny services in Mumbai from Tanya Maid Service.",
},

"/services/house-maid-service-in-mumbai": {
  title: "Full Time Maid Services in Mumbai | Tanya Maid Service",
  description:
    "Trusted full-time and part-time maid services in Mumbai for household support.",
},

"/services/cooking-service-in-mumbai": {
  title: "Cook Service in Mumbai | Tanya Maid Service",
  description:
    "Hire professional cooks and cooking maids in Mumbai for home cooking services.",
},

"/services/driver-service-in-mumbai": {
  title: "Driver Service in Mumbai | Tanya Maid Service",
  description:
    "Affordable and trusted driver services in Mumbai for personal and family travel.",
},

"/services/home-cleaning-service-in-mumbai": {
  title: "Home Cleaning Services Mumbai | Tanya Maid Service",
  description:
    "Professional home cleaning maid services in Mumbai for apartments and homes.",
},

"/services/japa-maid-service-in-mumbai": {
  title: "Japa Maid Service Mumbai | Tanya Maid Service",
  description:
    "Experienced japa maids in Mumbai for newborn baby and mother care support.",
},

    "/faq": {
      title: "FAQs | Tanya Maid Service Mumbai",
      description:
        "Frequently asked questions about maid, babysitter, cook and patient care services in Mumbai.",
    },

    "/blog": {
      title: "Tanya Maid Blog | Maid Service Tips Mumbai",
      description:
        "Read helpful maid service tips, guides and home care blogs from Tanya Maid Service Mumbai.",
    },

    "/privacy-policy": {
      title: "Privacy Policy | Tanya Maid Service",
      description:
        "Read the privacy policy of Tanya Maid Service Mumbai.",
    },

    "/terms-conditions": {
      title: "Terms & Conditions | Tanya Maid Service",
      description:
        "Read terms and conditions of Tanya Maid Service Mumbai.",
    },
  };

  if (location.pathname.startsWith("/blog/")) {
  return (
    <Helmet>
      <title>Tanya Maid Blog | Maid Service Tips Mumbai</title>

      <meta
        name="description"
        content="Read helpful maid service tips and guides from Tanya Maid Service Mumbai."
      />

      <link
        rel="canonical"
        href={`https://www.tanyamaidservice.com${location.pathname}`}
      />

      <meta
        property="og:title"
        content="Tanya Maid Blog | Maid Service Tips Mumbai"
      />

      <meta
        property="og:description"
        content="Read helpful maid service tips and guides from Tanya Maid Service Mumbai."
      />

      <meta
        property="og:image"
        content="https://www.tanyamaidservice.com/tanya-maid-logo.png"
      />
    </Helmet>
  );
}

  const currentSEO =
    seoData[location.pathname] || {
      title: "Tanya Maid Service",
      description:
        "Professional maid services in Mumbai.",
    };

  const currentUrl =
    `https://www.tanyamaidservice.com${location.pathname}`;

  return (
    <Helmet>

      {/* TITLE */}
      <title>{currentSEO.title}</title>

      {/* META DESCRIPTION */}
      <meta
        name="description"
        content={currentSEO.description}
      />

      {/* CANONICAL */}
      <link
        rel="canonical"
        href={currentUrl}
      />

      {/* OG TAGS */}
      <meta
        property="og:title"
        content={currentSEO.title}
      />

      <meta
        property="og:description"
        content={currentSEO.description}
      />

      <meta
        property="og:type"
        content="website"
      />

      <meta
        property="og:url"
        content={currentUrl}
      />

      <meta
        property="og:image"
        content="https://www.tanyamaidservice.com/tanya-maid-logo.png"
      />

      {/* TWITTER */}
      <meta
        name="twitter:card"
        content="summary_large_image"
      />

    </Helmet>
  );
};

export default SEO;